import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    linkedSignal,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
} from "@angular/core";
import { S25EditableAbstract } from "../s25.editable.abstract";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-editable-date-time")
@Component({
    selector: "s25-ng-editable-date-time",
    template: `
        <s25-ng-editable-date
            [(val)]="date"
            (valChange)="setDate()"
            [inputId]="dateInputId"
            [ariaLabel]="ariaLabel()"
            [allowEmpty]="allowEmpty"
            [alwaysEditing]="alwaysEditing"
        ></s25-ng-editable-date>
        <s25-timepicker
            [(modelValue)]="time"
            [defaultZero]="true"
            (modelValueChange)="setDate()"
            [class.hidden]="!value()"
        ></s25-timepicker>
    `,
    styles: `
        :host {
            display: block;
        }

        .hidden {
            visibility: hidden;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableDateTimeComponent extends S25EditableAbstract<any> implements OnInit, OnChanges {
    @Input() outputString: boolean = false;
    // TODO: consolidate with fieldId
    @Input() dateInputId?: string;

    readonly date = linkedSignal(() => {
        const value = this.value();
        if (!value && !this.allowEmpty) {
            return new Date();
        } else if (!!value) {
            return S25Util.date.clone(value);
        }
        return value;
    });
    readonly time = linkedSignal(() => {
        const value = this.value();
        if (!value && !this.allowEmpty) {
            return new Date();
        } else if (!!value) {
            return S25Util.date.clone(value);
        }
        return value;
    });

    getType = () => "date";

    private readonly cd = inject(ChangeDetectorRef);

    ngOnChanges(changes: SimpleChanges) {
        if (changes.val) {
            if (typeof this.val === "string") this.val = new Date(this.val);
        }
    }

    ngOnInit() {
        this.cd.detectChanges();
    }

    setDate() {
        const newDate = S25Util.date.clone(this.date() ?? new Date());
        if (this.time()) S25Util.date.copyTime(newDate, this.time());
        this.value.set(newDate);
        this.emit();
        this.cd.detectChanges();
    }

    emit() {
        if (!this.outputString) this.valChange.emit(this.value());
        else this.valChange.emit(this.value().toISOString());
    }
}
